import Status from '../components/Status';
import Request from '@/core/QuRequest';
// import { adPosition, auditResults } from '../conf';
import { adPosition, advType } from '../conf';
import IconScalePlus from '@/assets/image/icon/scale-plus-icon.png';
import { Item, Log, Product, Contact, Other, Agent, License, Wrapper } from './components';
import { Title, FormDialog } from '@/components';

const req = new Request();

export default {
    components: { Title, Item, Status, FormDialog, Log, Product, Contact, Other, Agent, License, Wrapper },
    computed: {
        loadingView () {
            return (this.steps || []).length <= 0 || (this.brands || []).length <= 0;
        },
        // 是否已有开户内容 info
        hasInfo () {
            return !!(this.detail || {}).customer_info_id;
        },
        contacterData () {
            // to array
            // eslint-disable-next-line camelcase
            const { contacter, contacter_email, contacter_phone } = this.detail || {};
            return [{ contacter, contacter_email, contacter_phone }];
        },
        itemContent () {
            // eslint-disable-next-line camelcase
            const { company, owner_name, customer_id, brand } = this.detail || {};
            return { company, owner_name, customer_id, brand };
        },
        license () {
            return ((this.detail || {}).license || '').split(',');
        },
        qualification () {
            return ((this.detail || {}).qualification || '').split(',');
        }
    },
    data () {
        return {
            customerId: '',
            iconScalePlus: IconScalePlus,
            adPosition,
            advType,
            categoryOps: [],
            steps: null,
            brands: null,
            config: [],
            id: '',
            loading: false,
            detail: {},
            logInfo: {},
            productOpt: [],
            addProductForm: {
                loading: false,
                display: false,
                rules: {
                    product: [{ required: true, type: 'array', message: '合作产品必选', triggle: 'change' }]
                },
                form: {
                    product: ''
                }
            }
        };
    },
    methods: {
        // 获取所有的跟进步骤
        async _getSteps () {
            try {
                const params = {
                    type: '1'
                };
                const res = await req.send(req.Apis.sales.common.config, params);
                if (res.code === 200) {
                    this.steps = [...res.data] || [];
                }
            } catch (err) {
                console.error(`获取进步骤失败：${err.message || '未知错误'}`);
            }
        },

        // 获取品牌
        async _getBrands () {
            try {
                const params = {
                    type: '2'
                };
                const res = await req.send(req.Apis.sales.common.config, params);
                if (res.code === 200) {
                    this.brands = [...res.data] || [];
                }
            } catch (err) {
                console.error(`获取品牌失败：${err.message || '未知错误'}`);
            }
        },

        // 获取详情
        async _getDetail () {
            try {
                const params = {
                    customer_id: this.customerId,
                    type: this.type || '',
                    owner: this.owner || ''
                };
                this.loading = true;
                // req
                const res = await req.send(req.Apis.sales.customerStage2.detail, params);
                this.detail = {
                    ...res.data
                };
                this.loading = false;
            } catch (err) {
                this.$message.error(`获取详情失败：${err.message || '未知错误'}`);
            }
        },

        // 获取广告主相关日志接口（单独拎出来）
        async _getLogInfo () {
            try {
                const params = {
                    customer_id: this.customerId
                };
                this.loading = true;
                // req
                const res = await req.send(req.Apis.sales.customerStage2.customerLog, params);
                this.logInfo = {
                    ...res.data
                };
                this.loading = false;
            } catch (err) {
                console.error(`获取失败：${err.message || '未知错误'}`);
            }
        },

        // 获取行业数据
        async _getCategoryConfig () {
            try {
                const res = await req.send(req.Apis.sales.common.category);
                this.categoryOps = res.data;
            } catch (err) {
                this.$message.error(`获取行业数据失败：${err.message || '未知错误'}`);
            }
        },

        checkBind (productItem = {}) {
            // is_bind：产品是否被绑定 0否, 1 2 3等表示是
            if (productItem.is_bind && productItem.is_bind !== '0') {
                return true;
            } else {
                return false;
            }
        },

        disableTip (item = {}) {
            let tip = '不可绑定';
            if (item.is_bind && item.is_bind !== '0') {
                if (item.customer_id === this.customerId) {
                    tip = '此产品已经被此客户绑定，可以去【归属查询】页面查询归属';
                } else {
                    tip = `此产品已经被【${item.company}】绑定，可以去【归属查询】页面查询归属`;
                }
            }
            return tip;
        },

        // 添加产品
        handleAddProduct () {
            this.addProductForm.display = true;
        },

        async _fetchProduct (key) {
            try {
                const params = {
                    name: key || '',
                    page_size: 50,
                    status: 0
                };
                const res = await req.send(req.Apis.sales.customerStage2.productOwner, params);
                let resData = [...(res.data || [])];
                this.productOpt = this.addOptions(this.productOpt, resData);
                this.optionScrollToTop();
            } catch (err) {
                console.error(`获取产品失败：${err.message || '未知错误'}`);
            }
        },

        // 累加
        addOptions (oldOptions = [], freshOptions = []) {
            let allOptions = [...freshOptions, ...oldOptions];
            let uniqueOptions = [];
            let temp = [];
            for (let i = 0; i < allOptions.length; i++) {
                if (temp.indexOf(allOptions[i].product_id) === -1) {
                    temp.push(allOptions[i].product_id);
                    uniqueOptions.push(allOptions[i]);
                }
            }
            return uniqueOptions;
        },

        optionScrollToTop () {
            this.$refs.productSelect.popperElm.querySelector('.el-scrollbar__wrap').scrollTop = 0;
        },

        closeAddProductDialog () {
            this.resetProductData();
        },

        resetProductData () {
            this.addProductForm.form.product = '';
            this.productOpt = [];
        },

        submitAddProductFormAction () {
            this.$refs['addProductForm'].validate(valid => {
                if (valid) {
                    this.processProductSubmit();
                } else {
                    return false;
                }
            });
        },

        // params: customer_id  product_ids
        async processProductSubmit () {
            try {
                this.submitLoading = true;
                const res = await req
                    .send(req.Apis.sales.customerStage2.bindProduct, {
                        customer_id: this.customerId || '',
                        product_ids: this.addProductForm.form.product.join(',') || ''
                    })
                    .fin(() => {
                        this.submitLoading = false;
                    });
                if (res.code === 200) {
                    this.addProductForm.display = false;
                    this.$message.success(`绑定产品成功`);
                    this.resetProductData();
                    this.refreshApis();
                }
            } catch (err) {
                this.$message({
                    message: `绑定产品失败：${err.message || '未知错误'}`,
                    type: 'error',
                    duration: 4000
                });
            }
        },

        // 监听更新进度
        onUpdateStepSucc () {
            // 刷新两个接口，更新两部分内容（日志内容，以及进度条内容）
            this.refreshApis();
        },

        /**
         * 匹配行业数据
         * @param {Array} ids eg: ['2342','532','5345']
         * @param {Array} ori categoryOps
         **/
        matchCategoryText (ids = [], ori = []) {
            if (ids.length <= 0 || ori.length <= 0) return '';

            let res = '';
            const queryIdx = (val = '', list = []) => list.findIndex(i => i.value === val);
            const idx = queryIdx(ids[0], ori);
            res += ` ${idx > -1 ? ori[idx].name : ''} -`;

            ids.shift();
            if (ids.length > 0 && (ori[idx].child || []).length > 0) {
                res += this.matchCategoryText(ids, ori[idx].child);
            }

            return res;
        },

        // 监听导入私海成功
        onImportSucc () {
            this.refreshApis();
        },

        // 监听释放到公海成功
        onExportSucc () {
            this.refreshApis();
        },

        refreshApis () {
            this._getLogInfo();
            this._getDetail();
        }
    },
    created () {
        this.customerId = this.$route.query.customerId || '';
        this.type = this.$route.query.type || '';
        this.owner = this.$route.query.owner || '';
        this._getSteps(); // common/config type = 1
        this._getBrands(); // common/config type = 2
        this._fetchProduct();
        this._getDetail();
        this._getLogInfo();
        this._getCategoryConfig();
    }
};
